'use client';

import styles from './DesignProductSection.module.scss';

type DesignProductSectionProps = {
  productName: string;
  colorName: string;
  sizeName: string;
};

/**
 * 商品情報セクション
 */
export function DesignProductSection({ productName, colorName, sizeName }: DesignProductSectionProps) {
  return (
    <div className={styles.productInfo}>
      <div className={styles.productInfoItems}>
        <div className={styles.productInfoItem}>
          <span className={styles.productInfoLabel}>商品：</span>
          <span className={styles.productInfoValue}>{productName}</span>
        </div>
        <div className={styles.productInfoItem}>
          <span className={styles.productInfoLabel}>カラー：</span>
          <span className={styles.productInfoValue}>{colorName}</span>
        </div>
        <div className={styles.productInfoItem}>
          <span className={styles.productInfoLabel}>サイズ：</span>
          <span className={styles.productInfoValue}>{sizeName}</span>
        </div>
      </div>
    </div>
  );
}

export default DesignProductSection;
